import {ShortObject} from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';
import {JsonObject, AbstractModel, JsonProperty} from '../../core/public-api';
import {ColumnForEdit} from '../../../../../app-misc/src/app/modules/admin-panel/data/column-for-edit';

export interface AccessConditionBlock {
  title: string;
  conditions: RoleAccess[]
}

@JsonObject('model.user.RoleAccess')
export class RoleAccess extends AbstractModel {
  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'title')
  title?: string;

  @JsonProperty(String, 'path')
  path?: string;

  @JsonProperty([ShortObject], 'roles')
  roles?: ShortObject[];

}
